import React from "react";
import { Container } from "react-bootstrap";
import { TbFileDescription, TbScale, TbShieldCheck, TbUsers } from "react-icons/tb";
import { BiRupee } from "react-icons/bi";
import { motion } from "framer-motion";
import "./RightsManagement.css";

const ServiceList = ({ services, heading }) => {
  const getIconAndClass = (index) => {
    switch (index) {
      case 0:
        return { icon: <TbFileDescription />, cardClass: "border-purple" };
      case 1:
        return { icon: <BiRupee />, cardClass: "border-orange" };
      case 2:
        return { icon: <TbScale />, cardClass: "border-pink" };
      case 3:
        return { icon: <TbShieldCheck />, cardClass: "border-purple" };
      case 4:
        return { icon: <TbUsers />, cardClass: "border-orange" };
      default:
        return { icon: <TbFileDescription />, cardClass: "border-purple" };
    }
  };

  return (
    <section className="rm-services">
      <Container>
        <motion.h3
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span style={{ color: "#f97316" }}>Comprehensive</span> <span className="text-gradient-purple">Music Right Management Services</span>
        </motion.h3>
        
        <div className="service-grid">
          {services.map((service, index) => {
            const { icon, cardClass } = getIconAndClass(index);
            const isRow2 = index > 2;
            return (
              <motion.div 
                key={index} 
                className={`rm-service-card ${cardClass} ${isRow2 ? 'card-row-2' : ''}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
              >
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="rm-service-icon">
                    {icon}
                  </div>
                  <h4>{service.heading}</h4>
                </div>
                <p>{service.detail}</p>
              </motion.div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default ServiceList;
